export default {
  "content": "<path d=\"M22 21h-7v-2h7v2zM8.073 3.5a2.5 2.5 0 012.236 1.382l2.249 4.497c.39-.104.77-.213 1.136-.331l.612 1.904c-.422.136-.858.26-1.306.378V20a1 1 0 01-1 1H8a1 1 0 01-1-1v-2H2v-2h6a1 1 0 011 1v2h2v-7.218c-2.505.481-6.26.718-9 .718v-2c2.616 0 6.214-.227 8.547-.669L8.521 5.776a.5.5 0 00-.448-.276H2v-2h6.073z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};